import React from 'react'

import googleAd_header_1 from '../images/googleAd_header_1'


export default function GoogleAdwords() {


  return <>
   <div class="page-wrapper sec-mar">
        <article
          id="post-15"
          class="post-15 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="15"
              class="elementor elementor-15"
            >
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-7570cb6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="7570cb6"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-no">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0751275"
                    data-id="0751275"
                    data-element_type="column"
                  >
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-96da640 elementor-widget elementor-widget-spinner_slider"
                        data-id="96da640"
                        data-element_type="widget"
                        data-widget_type="spinner_slider.default"
                      >
                        <div class="elementor-widget-container">
                          <script></script>

                          <div class="banner-section2">
                            <div class="banner2-spring1"></div>
                            <div class="banner2-spring2"></div>
                            <div class="banner2-circle1"></div>
                            <div class="banner2-circle2"></div>
                            <img
                              decoding="async"
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-vector.png"
                              class="banner2-vector"
                              alt="image"
                            />

                            
                            <div class="swiper banner2">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    // src={googleAd_header_1}
                                    src="https://media.istockphoto.com/id/1062607138/photo/writing-note-showing-seo-and-adwords-business-photo-showcasing-pay-per-click-digital.webp?b=1&s=170667a&w=0&k=20&c=KarGatU0f7ZjfVNUhTXoPT3WSfwZoN3UNcdrvSJhe3Y="
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  <div class="container">
                                    <div class="row d-flex justify-content-center align-items-center">
                                      <div class="col-xl-7 col-lg-10">
                                        <div class="banner2-content">
                                          <span>
                                            WE ARE TOP NOTCH MEDIA WORKS
                                          </span>
                                          <h2>GOOGLE ADWORDS
</h2>

                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-bg2-1.png"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  
                                </div> */}
                              </div>
                            </div>
                            <div class="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>

       {/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>GOOGLE ADWORDS


</b></h1>
<p>If You’re New To The Search Marketing World Or Just Want A Plain-English Description Of Certain Phrases And Tools In Digital, Then You’ve Come To The Right Place..




</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    {/* <span>-Employee Management


-</span>
                    <h3>
                    Employee Management


                    </h3> */}
                    <p class="para mb-0 ">
                    Here we’ll be looking at Google AdWords, Google’s own advertising service which allows you to place search results for your website on a search engine results page (SERP) by paying for them. There’s no need to wait for your new site to work its way organically up the rankings. By using paid search you can see immediate results and it’s not nearly as difficult to use or expensive as you may think.



                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://cdnwp.mobidea.com/academy/wp-content/uploads/2018/01/google-adwords-760x428.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://blog.dabrianmarketing.com/hubfs/Imported_Blog_Media/before-you-use-google-ad-words-featured-image-min-1-Dec-08-2020-01-47-18-78-AM.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    {/* <span>-Business Ethics



-</span>
                    <h3>
                    Business Ethics




                    </h3> */}
                    <p class="para mb-0 ">
                    Paid search is the term we use for advertising within the listings of a search engine. These normally appear at the top of a SERP or to the side, and increasingly look more and more like organic results. At the moment Google places a small yellow ‘Ad’ label on them. Google isn’t the only search engine where you can do this, Yahoo and Bing also run their own advertising network, called the Yahoo Bing Network. For now though, let’s take a look at Google AdWords…



.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Basic Principles Of AdWordst


-</span>
                    <h3>
                    Basic Principles Of AdWords

                    </h3>
                    <p class="para mb-0 ">
                    Basically you pick some keywords that a searcher might use on Google, then create an advert that will appear on the SERP based on those keywords, such as this. Of course you’re probably not going to be the only company wanting to serve adverts to people who use those particular terms. often causing the top of a search engine results page to look like this. If you want your ad to appear at all, you have to bid against other marketers on how much you’re willing to pay Google AdWords every time a searcher clicks on your ad. Obviously the more you pay-per-click (PPC) the more likely your ad will appear in the search results. However, and this is a big however, unlike other real-time bidding models, it’s not just the highest bid that is taken into account. Google…




                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11 mt-5">
                       
                        </div>
                     
                        <img src="https://www.bounteous.com/sites/default/files/insights/2020-02/previews/02132020_blog_connecting-analytics-app-web-to-google-ads_website.png" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="row text-center">
          <h1><b>Our Team For You</b></h1>
          <ul class="para mb-0 ">
            <li> 1. Well experienced.</li>
            <li> 2. AdWords and Bing Certified.</li>
            <li> 3. Works with perfect plan & full Transparency for better outcome.</li>
            <li> 4. Have proven track record of work and achievements.</li>
          </ul>
          <br />
          <br />
          <p class="para mb-0 ">
           
We also use business goals to customize the pay per click advertisement campaigns on Google AdWords.
Best in targeting is filter data and using it for best setup of any campaign for example:- Negative keywords or labelling of group performing keywords is used
according to the business with which you can filter after running PPC campaigns and generate more ROI in less budget.</p>
        </div>
      </div>


  </>

}
